import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CallSettingDashboardComponent } from './call-setting-dashboard/call-setting-dashboard.component';
import { CallSettingComponent } from './call-setting.component';
import { AuthGuard } from '../guard/auth.guard';

const routes: Routes = [
  { path: '', redirectTo:'', pathMatch:'full' },
  { path: '', component: CallSettingComponent, children:[
    { path: '', redirectTo:'call-setting-dashboard', pathMatch:'full' },
    { path: 'call-setting-dashboard', component: CallSettingDashboardComponent, canActivate: [AuthGuard] },
  ] },
  
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CallSettingRoutingModule { }
